<!-- Header Section -->
<div class="bg-white border-b border-gray-200 shadow-sm">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
    <div class="flex items-center justify-between">
      <div class="flex items-center space-x-4">
        <button 
          class="inline-flex items-center p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors duration-200"
          onclick="history.back()">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
        </button>
        <div>
          <h1 class="text-2xl font-bold text-gray-900">Gestión de Cobro</h1>
          <p class="text-sm text-gray-500 mt-1">Visualización de cuotas pendientes como las ve el cliente</p>
        </div>
      </div>
      <div class="flex items-center space-x-2 text-sm">
        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
          <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 2L3 7v11a1 1 0 001 1h12a1 1 0 001-1V7l-7-5z"/>
          </svg>
          Solo lectura
        </span>
      </div>
    </div>
  </div>
</div>

<!-- Loading State -->
<div *ngIf="isLoading" class="min-h-screen flex items-center justify-center">
  <div class="text-center">
    <div class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
    <p class="text-gray-600 text-lg font-medium">Cargando cuotas pendientes...</p>
    <p class="text-gray-400 text-sm mt-2">Por favor espere un momento</p>
  </div>
</div>

<!-- Error State -->
<div *ngIf="hasError && !isLoading" class="min-h-screen flex items-center justify-center">
  <div class="text-center max-w-md mx-auto px-4">
    <div class="bg-red-100 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
      <svg class="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
      </svg>
    </div>
    <h3 class="text-lg font-semibold text-gray-900 mb-2">Error al cargar las cuotas</h3>
    <p class="text-gray-600 mb-6">{{ errorMessage }}</p>
    <button 
      (click)="retryLoad()" 
      class="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-200">
      <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
      </svg>
      Reintentar
    </button>
  </div>
</div>

<!-- Main Content -->
<div *ngIf="!isLoading && !hasError" class="min-h-screen">
  <div class="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8 h-full">
    
    <!-- Empty State -->
    <div *ngIf="quoteList.length === 0" class="text-center py-16">
      <div class="bg-gray-100 rounded-full p-6 w-20 h-20 mx-auto mb-6 flex items-center justify-center">
        <svg class="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
      </div>
      <h3 class="text-xl font-semibold text-gray-900 mb-2">No hay cuotas pendientes</h3>
      <p class="text-gray-500 max-w-sm mx-auto">Este cliente no tiene cuotas pendientes por pagar.</p>
    </div>

    <!-- Installments List -->
    <div *ngIf="quoteList.length > 0" class="grid grid-cols-1 xl:grid-cols-3 gap-8">
      
      <!-- Left Column - Installments -->
      <div class="xl:col-span-2 space-y-4">
        
        <!-- Controls Header -->
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <div class="flex items-center justify-between">
            <h2 class="text-lg font-semibold text-gray-900">Cuotas Pendientes</h2>
            <button 
              (click)="selectAllQuotes()"
              class="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors duration-200">
              <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              Seleccionar Todo
            </button>
          </div>
        </div>

        <!-- Banner informativo: pago por conciliar disponible -->
        <div *ngIf="conciliarTotal > 0"
             class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
          <div class="flex items-start gap-2 mb-3">
            <i class="fas fa-info-circle text-blue-600 mt-0.5"></i>
            <div class="text-sm text-blue-900 flex-1">
              El cliente tiene <strong>${{ conciliarTotal.toFixed(2) }}</strong>
              en pagos pendientes de conciliar. Cuando se concilien, se distribuirían así:
            </div>
          </div>

          <!-- Detalle de pagos individuales -->
          <div *ngIf="pendingPayments.length > 0" class="ml-6 mb-3 space-y-2">
            <div *ngFor="let p of pendingPayments"
                 class="bg-white border border-blue-100 rounded px-3 py-2 text-xs">
              <div class="flex items-center justify-between">
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2 mb-0.5">
                    <span class="font-mono text-gray-500">{{ p.code }}</span>
                    <button (click)="copyInvoiceCode(p.code)"
                            class="text-blue-500 hover:text-blue-700 text-xs"
                            title="Copiar código">
                      <i class="fas fa-copy"></i>
                    </button>
                    <button (click)="openPaymentDetail(paymentcontainer, p.code)"
                            class="text-blue-500 hover:text-blue-700 text-xs"
                            title="Ver detalle del pago">
                      <i class="fas fa-eye"></i>
                    </button>
                  </div>
                  <div class="text-gray-700">
                    <span *ngIf="p.payment_method">{{ p.payment_method }}</span>
                    <span *ngIf="p.payment_method && p.reference"> · Ref. {{ p.reference }}</span>
                    <span *ngIf="!p.payment_method && p.reference">Ref. {{ p.reference }}</span>
                  </div>
                  <div class="text-gray-500 text-xs mt-0.5">
                    <i class="far fa-calendar mr-1"></i>
                    {{ p.register_payment_date || p.date | date:'dd MMM y, h:mm a' }}
                  </div>
                </div>
                <div class="text-right ml-2">
                  <div class="font-bold text-gray-900">${{ p.amount.toFixed(2) }}</div>
                  <div *ngIf="p.totalPaymentDue !== p.amount" class="text-xs text-gray-500">
                    Por aplicar: ${{ p.totalPaymentDue.toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="ml-6 space-y-1 text-sm border-t border-blue-200 pt-2">
            <div *ngIf="sumAppliedC001 > 0" class="flex items-center justify-between">
              <span class="text-gray-700">
                <i class="fas fa-circle text-red-500 mr-1" style="font-size:6px;vertical-align:middle"></i>
                Cubriría Penalidad de incumplimiento
              </span>
              <span class="font-semibold text-red-700">−${{ sumAppliedC001.toFixed(2) }}</span>
            </div>
            <div *ngIf="sumAppliedInstallments > 0" class="flex items-center justify-between">
              <span class="text-gray-700">
                <i class="fas fa-circle text-blue-500 mr-1" style="font-size:6px;vertical-align:middle"></i>
                Cubriría {{ countInstallmentsCovered }} cuota{{ countInstallmentsCovered > 1 ? 's' : '' }}
              </span>
              <span class="font-semibold text-blue-700">−${{ sumAppliedInstallments.toFixed(2) }}</span>
            </div>
            <div *ngIf="sumAppliedC004 > 0" class="flex items-center justify-between">
              <span class="text-gray-700">
                <i class="fas fa-circle text-orange-500 mr-1" style="font-size:6px;vertical-align:middle"></i>
                Cubriría Penalidad de reactivación
              </span>
              <span class="font-semibold text-orange-700">−${{ sumAppliedC004.toFixed(2) }}</span>
            </div>
            <div *ngIf="sumLeftover > 0" class="flex items-center justify-between pt-1 border-t border-blue-200 mt-1">
              <span class="text-gray-600 italic">
                <i class="fas fa-piggy-bank text-gray-400 mr-1"></i>
                Quedaría sin distribuir (saldo a favor)
              </span>
              <span class="font-semibold text-gray-700">${{ sumLeftover.toFixed(2) }}</span>
            </div>
          </div>
        </div>

        <!-- Installments Cards -->
        <div class="space-y-4 pb-6">
          <div
            *ngFor="let quote of quoteList; let i = index"
            class="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow duration-200">
            <div class="p-6">
              <div class="flex items-center justify-between">
                
                <!-- Checkbox and Content -->
                <div class="flex items-start space-x-4 flex-1">
                  <!-- Checkbox -->
                  <div class="flex items-center pt-1">
                    <input 
                      type="checkbox" 
                      [id]="'quote-' + i"
                      [checked]="quote.isChecked"
                      [disabled]="!canSelectQuote(i)"
                      (change)="onCheckboxChange(quote, i)"
                      class="h-4 w-4 text-blue-600 border-2 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 disabled:opacity-50 disabled:cursor-not-allowed">
                  </div>
                  
                  <!-- Quote Info -->
                  <div class="flex-1 min-w-0">
                    <!-- Date and Store -->
                    <div class="flex items-center justify-between mb-2">
                      <h3 class="text-base font-medium text-gray-900">
                        {{ quote.scheduledPaymentDate | date:'MMM d, y' }}
                      </h3>
                      <span 
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                        [ngClass]="getQuoteStatusColor(quote)">
                        {{ getQuoteStatusText(quote) }}
                      </span>
                    </div>
                    
                    <!-- Número de la cuota (installment.order; el API no manda el total de cuotas del crédito) -->
                    <p class="text-sm font-medium text-gray-700 mb-1" *ngIf="quote.order !== null && quote.order !== undefined">Cuota {{ quote.order }}<span *ngIf="quote.total_installments"> de {{ quote.total_installments }}</span></p>

                    <!-- Store Name -->
                    <!-- P-163: factura sin tienda = Mundo Total -->
                    <p class="text-sm text-gray-600 mb-2">{{ quote.shop?.short_name || 'Mundo Total' }}</p>
                    
                    <!-- Invoice Code -->
                    <div class="flex items-center text-xs text-gray-400 mb-2">
                      <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                      </svg>
                      <span>Crédito: </span>
                      <button 
                        (click)="copyInvoiceCode(quote.invoice.identifier)"
                        class="text-blue-500 hover:text-blue-700 hover:underline focus:outline-none focus:text-blue-700 transition-colors duration-200"
                        title="Clic para copiar código completo">
                        {{ quote.invoice.identifier }}
                      </button>
                    </div>
                    <!-- Comercio del crédito de esta cuota (multicomercio, informativo) -->
                    <div class="text-xs text-gray-500 mb-2">Comercio: <span class="font-medium text-gray-700">{{ comercioDeCuota(quote) }}</span></div>
                    
                    <!-- Time Info -->
                    <div class="flex items-center text-xs text-gray-500">
                      <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      <span>{{ getRemainingDaysText(quote.scheduledPaymentDate) }}</span>
                    </div>
                  </div>
                </div>
                
                <!-- Amount -->
                <div class="text-right ml-6">
                  <div class="text-lg font-semibold text-gray-900">
                    ${{ quote.pendigAmount.toFixed(2) }}
                  </div>
                  <div class="text-xs text-gray-500">USD</div>
                  <div class="text-sm text-gray-600 mt-1" *ngIf="exchangeRate > 0">
                    Bs. {{ formatBolivars(quote.pendigAmount) }}
                  </div>
                </div>
              </div>

              <!-- Desglose simulación de pago por conciliar (informativo, opcional) -->
              <div *ngIf="quote.sim_applied && quote.sim_applied > 0"
                   class="mt-4 pt-3 border-t border-gray-100 text-sm space-y-1">
                <div class="flex items-center justify-between text-blue-700">
                  <span><i class="fas fa-arrow-down mr-1"></i> Pago por conciliar aplicaría</span>
                  <span class="font-semibold">−${{ quote.sim_applied.toFixed(2) }}</span>
                </div>
                <div *ngIf="!quote.sim_completed" class="flex items-center justify-between text-orange-700">
                  <span class="font-semibold">Quedaría debiendo</span>
                  <span class="font-bold">${{ (quote.sim_remaining || 0).toFixed(2) }}</span>
                </div>
                <div *ngIf="quote.sim_completed" class="flex items-center text-green-700">
                  <i class="fas fa-check-circle mr-1"></i>
                  <span class="text-xs">Quedaría cubierta completamente</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column - Summary -->
      <div class="xl:col-span-1">
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sticky top-24">
          <h3 class="text-lg font-semibold text-gray-900 mb-6">Resumen de Pago</h3>
          
          <div class="space-y-4">
            
            <!-- Selected Amount -->
            <div class="flex justify-between items-center py-3 border-b border-gray-100">
              <span class="text-sm font-medium text-gray-700">Monto seleccionado:</span>
              <div class="text-right">
                <span class="text-lg font-semibold text-gray-900">${{ totalSelected.toFixed(2) }}</span>
                <div class="text-xs text-gray-500" *ngIf="exchangeRate > 0">
                  Bs. {{ formatBolivars(totalSelected) }}
                </div>
              </div>
            </div>
            
            <!-- Penalty Fees (C001) -->
            <div *ngIf="totalPenaltyFee > 0" class="py-3 border-b border-gray-100">
              <div class="flex justify-between items-center">
                <span class="text-sm font-medium text-gray-700">Penalidad de incumplimiento:</span>
                <div class="text-right">
                  <span class="text-lg font-semibold text-red-600">${{ totalPenaltyFee.toFixed(2) }}</span>
                  <div class="text-xs text-gray-500" *ngIf="exchangeRate > 0">
                    Bs. {{ formatBolivars(totalPenaltyFee) }}
                  </div>
                </div>
              </div>
              <!-- Desglose simulación (solo si hay cobertura por pago por conciliar) -->
              <div *ngIf="sumAppliedC001 > 0" class="mt-2 pt-2 border-t border-gray-100 space-y-1 text-xs">
                <div class="flex items-center justify-between text-blue-700">
                  <span><i class="fas fa-arrow-down mr-1"></i> Pago por conciliar cubriría</span>
                  <span class="font-semibold">−${{ sumAppliedC001.toFixed(2) }}</span>
                </div>
                <div *ngIf="(totalPenaltyFee - sumAppliedC001) > 0.01" class="flex items-center justify-between text-orange-700">
                  <span class="font-semibold">Quedaría debiendo</span>
                  <span class="font-bold">${{ (totalPenaltyFee - sumAppliedC001).toFixed(2) }}</span>
                </div>
                <div *ngIf="(totalPenaltyFee - sumAppliedC001) <= 0.01" class="flex items-center text-green-700">
                  <i class="fas fa-check-circle mr-1"></i>
                  <span>Quedaría cubierta completamente</span>
                </div>
              </div>
            </div>

            <!-- Totales agrupados (cuando hay penalidad de reactivación) -->
            <div *ngIf="totalReactivationFee > 0" class="bg-gray-50 -mx-6 px-6 py-4 rounded-lg space-y-4">

              <!-- Total sin reactivación -->
              <div class="flex justify-between items-center">
                <span class="text-base font-bold text-gray-900">Total sin penalidad de reactivación:</span>
                <div class="text-right">
                  <span class="text-xl font-bold"
                        [class.text-gray-400]="totalCoveredWithoutReact > 0"
                        [class.line-through]="totalCoveredWithoutReact > 0"
                        [class.text-gray-900]="totalCoveredWithoutReact === 0">${{ totalWithoutReactivation.toFixed(2) }}</span>
                  <div class="text-sm text-gray-600 font-medium" *ngIf="exchangeRate > 0">
                    Bs. {{ formatBolivars(totalWithoutReactivation) }}
                  </div>
                </div>
              </div>
              <!-- Cobertura por pago por conciliar (solo si hay) -->
              <div *ngIf="totalCoveredWithoutReact > 0" class="space-y-1 -mt-2 pt-1 border-t border-gray-200">
                <div class="flex justify-between items-center text-sm text-blue-700">
                  <span><i class="fas fa-arrow-down mr-1"></i> Pago por conciliar cubriría</span>
                  <span class="font-semibold">−${{ totalCoveredWithoutReact.toFixed(2) }}</span>
                </div>
                <div class="flex justify-between items-center pt-1">
                  <span class="text-base font-bold text-gray-900">Total a pagar después de conciliar:</span>
                  <div class="text-right">
                    <span class="text-xl font-bold text-green-700">${{ totalWithoutReactivationAfterConciliar.toFixed(2) }}</span>
                    <div class="text-sm text-gray-600 font-medium" *ngIf="exchangeRate > 0">
                      Bs. {{ formatBolivars(totalWithoutReactivationAfterConciliar) }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Divisor -->
              <div class="border-t border-gray-300"></div>

              <!-- Penalidad de reactivación (C004) — justo antes del total con penalidad -->
              <div>
                <div class="flex justify-between items-center">
                  <span class="text-sm font-medium text-gray-700">Penalidad de reactivación:</span>
                  <div class="text-right">
                    <span class="text-lg font-semibold text-orange-600">${{ totalReactivationFee.toFixed(2) }}</span>
                    <div class="text-xs text-gray-500" *ngIf="exchangeRate > 0">
                      Bs. {{ formatBolivars(totalReactivationFee) }}
                    </div>
                  </div>
                </div>
                <!-- Desglose simulación C004 (solo si hay cobertura) -->
                <div *ngIf="sumAppliedC004 > 0" class="mt-2 pt-2 border-t border-gray-100 space-y-1 text-xs">
                  <div class="flex items-center justify-between text-blue-700">
                    <span><i class="fas fa-arrow-down mr-1"></i> Pago por conciliar cubriría</span>
                    <span class="font-semibold">−${{ sumAppliedC004.toFixed(2) }}</span>
                  </div>
                  <div *ngIf="(totalReactivationFee - sumAppliedC004) > 0.01" class="flex items-center justify-between text-orange-700">
                    <span class="font-semibold">Quedaría debiendo</span>
                    <span class="font-bold">${{ (totalReactivationFee - sumAppliedC004).toFixed(2) }}</span>
                  </div>
                  <div *ngIf="(totalReactivationFee - sumAppliedC004) <= 0.01" class="flex items-center text-green-700">
                    <i class="fas fa-check-circle mr-1"></i>
                    <span>Quedaría cubierta completamente</span>
                  </div>
                </div>
              </div>

              <!-- Total con reactivación -->
              <div class="flex justify-between items-center">
                <span class="text-base font-bold text-gray-900">Total con penalidad de reactivación:</span>
                <div class="text-right">
                  <span class="text-xl font-bold"
                        [class.text-gray-400]="totalCoveredWithReact > 0"
                        [class.line-through]="totalCoveredWithReact > 0"
                        [class.text-gray-900]="totalCoveredWithReact === 0">${{ totalWithReactivation.toFixed(2) }}</span>
                  <div class="text-sm text-gray-600 font-medium" *ngIf="exchangeRate > 0">
                    Bs. {{ formatBolivars(totalWithReactivation) }}
                  </div>
                  <div class="text-xs text-gray-400" *ngIf="exchangeRate > 0">
                    Tasa: {{ exchangeRate.toLocaleString('es-VE', { minimumFractionDigits: 2 }) }} Bs/$
                  </div>
                </div>
              </div>
              <!-- Cobertura por pago por conciliar (solo si hay) -->
              <div *ngIf="totalCoveredWithReact > 0" class="space-y-1 -mt-2 pt-1 border-t border-gray-200">
                <div class="flex justify-between items-center text-sm text-blue-700">
                  <span><i class="fas fa-arrow-down mr-1"></i> Pago por conciliar cubriría</span>
                  <span class="font-semibold">−${{ totalCoveredWithReact.toFixed(2) }}</span>
                </div>
                <div class="flex justify-between items-center pt-1">
                  <span class="text-base font-bold text-gray-900">Total a pagar después de conciliar:</span>
                  <div class="text-right">
                    <span class="text-xl font-bold text-green-700">${{ totalWithReactivationAfterConciliar.toFixed(2) }}</span>
                    <div class="text-sm text-gray-600 font-medium" *ngIf="exchangeRate > 0">
                      Bs. {{ formatBolivars(totalWithReactivationAfterConciliar) }}
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <!-- Total único (cuando NO hay fee de reactivación) -->
            <div *ngIf="totalReactivationFee === 0" class="py-4 bg-gray-50 -mx-6 px-6 rounded-lg space-y-2">
              <div class="flex justify-between items-center">
                <span class="text-base font-semibold text-gray-900">Total a pagar:</span>
                <div class="text-right">
                  <span class="text-xl font-bold"
                        [class.text-gray-400]="totalCoveredWithoutReact > 0"
                        [class.line-through]="totalCoveredWithoutReact > 0"
                        [class.text-gray-900]="totalCoveredWithoutReact === 0">${{ totalAmount.toFixed(2) }}</span>
                  <div class="text-sm text-gray-600 font-medium" *ngIf="exchangeRate > 0">
                    Bs. {{ formatBolivars(totalAmount) }}
                  </div>
                  <div class="text-xs text-gray-400" *ngIf="exchangeRate > 0">
                    Tasa: {{ exchangeRate.toLocaleString('es-VE', { minimumFractionDigits: 2 }) }} Bs/$
                  </div>
                </div>
              </div>
              <!-- Cobertura por pago por conciliar (solo si hay) -->
              <div *ngIf="totalCoveredWithoutReact > 0" class="space-y-1 pt-2 border-t border-gray-200">
                <div class="flex justify-between items-center text-sm text-blue-700">
                  <span><i class="fas fa-arrow-down mr-1"></i> Pago por conciliar cubriría</span>
                  <span class="font-semibold">−${{ totalCoveredWithoutReact.toFixed(2) }}</span>
                </div>
                <div class="flex justify-between items-center pt-1">
                  <span class="text-base font-bold text-gray-900">Total a pagar después de conciliar:</span>
                  <div class="text-right">
                    <span class="text-xl font-bold text-green-700">${{ totalWithoutReactivationAfterConciliar.toFixed(2) }}</span>
                    <div class="text-sm text-gray-600 font-medium" *ngIf="exchangeRate > 0">
                      Bs. {{ formatBolivars(totalWithoutReactivationAfterConciliar) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Domiciliation Process Warning -->
            <div *ngIf="inDomiciliationProcess" class="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
              <div class="flex items-start">
                <svg class="w-5 h-5 text-yellow-600 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                </svg>
                <div>
                  <h4 class="text-sm font-medium text-yellow-900 mb-1">Proceso de domiciliación activo</h4>
                  <p class="text-sm text-yellow-700">Este cliente tiene un proceso de domiciliación bancaria en curso.</p>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Offcanvas: detalle del pago — mismo patrón que contact-financial-payments / person-fee-payments -->
<ng-template #paymentcontainer let-offcanvas>
  <div class="offcanvas-header">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="row">
            <div class="col-10">
              <div class="text-capitalize h5 text-secondary mt-2">
                Detalle de Pago
              </div>
            </div>
            <div class="col-2 text-end pt-2">
              <button type="button" class="btn-close" aria-label="Close"
                      (click)="offcanvas.dismiss('Cross click');"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="offcanvas-body">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="text-start">
            <app-person-payments
              [code_person]="params_payment['person_code']"
              [code_payment]="params_payment['code_payment']"
              (resetStatus)="paymentDetailResponse($event)">
            </app-person-payments>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template> 